module.exports = __webpack_public_path__ + "static/media/cat-leisure.913574f0.svg";